import {createAction} from '@reduxjs/toolkit';

export const updateDataDisplayCheckbox = createAction('dataDisplay/updateCheckbox');
export const updateDataDisplayRadioButton = createAction('dataDisplay/updateRadioButton');
